import type { AuthProviderProps } from 'react-oidc-context'

import { getPostSigninPath } from '@/lib/authRedirect'
import { router } from '@/router'

export const oidcConfig: AuthProviderProps = {
  authority: `${import.meta.env.VITE_APP_OAUTH_PROVIDER_URL}/oidc/2`,
  client_id: import.meta.env.VITE_APP_ONELOGIN_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_APP_ONELOGIN_REDIRECT_URL,
  post_logout_redirect_uri: import.meta.env.VITE_APP_BASE_URL,
  response_type: 'code',
  scope: 'openid',
  automaticSilentRenew: true,
  onSigninCallback: (user) => {
    router.history.replace(getPostSigninPath(user?.state))
  },
}
